import React from "react";
import PanelGroupController from "../../components/PanelGroupController";
import {fromJS} from "immutable";
import PropertiesList from "../../components/panels/PropertiesList";
import Loading from "../../components/Loading";
import GraphQLErrors from "../../components/GraphQLErrors";
import {Query} from "react-apollo";
import gql from "graphql-tag";

const MIGRATION = gql`
  query migration($customerId:ID!) {
    migration(customerId: $customerId) {
      customerId
      name
      email
      phone
      legacyUsername
      status
      errorCode
      error
    }
  }
`

const MigrationPropertiesPanel = (props) => {

  let elements = null;
  if (!props.customerId) {
    elements = <p className="u-no-selection">Nothing selected</p>
  } else {
    let properties = fromJS([
      {prop: "customerId", label: "Id", type: "customerId"},
      {prop: "name", label: "Name", type: "string"},
      {prop: "email", label: "Email", type: "string"},
      {prop: "phone", label: "Phone", type: "telephone"},
      {prop: "legacyUsername", label: "Username", type: "explicitId"},
      {prop: "status", label: "Status", type: "string"},
      {prop: "errorCode", label: "ErrorCode", type: "string"},
      {prop: "error", label: "Error", type: "string"},
    ])
    let variables = {customerId: props.customerId}
    elements = (
      <Query query={MIGRATION} variables={variables} skip={!props.customerId}>
        {({ loading, error, data }) => {
          if (loading) return <Loading />
          if (error) return <GraphQLErrors error={error} />
          return (
            <PropertiesList properties={properties} data={fromJS(data.migration)} />
          )
        }}
      </Query>
    )
  }

  return (
    <PanelGroupController title="Migration" expanded={props.expanded}>
      {elements}
    </PanelGroupController>
  )

}

export default MigrationPropertiesPanel;